import { render, staticRenderFns } from "./DestinationCard.vue?vue&type=template&id=051db8c6&scoped=true"
import script from "./DestinationCard.vue?vue&type=script&lang=js"
export * from "./DestinationCard.vue?vue&type=script&lang=js"
import style0 from "./DestinationCard.vue?vue&type=style&index=0&id=051db8c6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051db8c6",
  null
  
)

export default component.exports